export const colorTools = {

    methods: {

        convertToRgba(color, opacity = 1) {

            color = color.replace('#', '');

            let values = [
                parseInt(color.substring(0, 2), 16),
                parseInt(color.substring(2, 4), 16),
                parseInt(color.substring(4, 6), 16),
                opacity
            ];

            return 'rgba(' + values.join(',') + ')';
        },
    }
}

